import { CustomAppLayout } from '../../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { FormField, Pagination, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { format, parseISO } from 'date-fns';
import React, { useEffect, useMemo, useState } from 'react';
import BadgeUserType from '../../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../../components/selects/selectPaging';
import { fetchWithWatch } from '../../../../../../hooks/fetchWithWatch';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../../commons/functions';
const _preserve = React.version;

export const AdminMovementsPACSubscriptionsPage = () => {
    const { data, menu, parameters } = useGlobalState();
    useGlobalState();
    const [PACS, setPACS] = useState<any[]>([]);


    const handleRefresh = async () => {
        ///private/user/movements/pac/initsubscription
        setLoading(true);
        try {
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/admin/movements/pac/users',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify({ orderBy: "dateCreated", order: "desc", month: parameters?.month, year: parameters?.year, type: "subscription" }),
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const dataWeb = await response.json();

            if (dataWeb.code == 0) {
                setPACS(dataWeb.users.map((user: any) => ({
                    ...user,
                    institution: user.jsonFintoc?.payment_method?.pac?.institution?.name || "",
                    status: user.jsonFintoc?.payment_method?.pac?.status || "",
                    date: parseISO(user?.jsonFintoc?.payment_method?.created_at) || null,
                    accountType: user?.jsonFintoc?.payment_method?.pac?.account_type || "",
                    accountNumber: user?.jsonFintoc?.payment_method?.pac?.account_number || ""
                })))
            }
        } catch (error: any) {
        } finally { setLoading(false); }
    }
    useEffect(() => {
        handleRefresh();
    }, [parameters.period]);

    const error = (item: any) => {
        if (item) {
            if (item === "login_invalid_credentials")
                return "Credenciales inválidas";
            else if (item === "login_credentials_locked")
                return "Credenciales bloquedas";
            else if (item === "authorization_failed")
                return "Autorización fallida";
            else if (item === "authorization_timeout")
                return "Autorización expirada";
            else if (item === "request_timeout")
                return "Tiempo de espera agotado";
            else if (item === "subscription_intent_expired")
                return "Intento de suscripción expirado";
            else if (item === "internal_error")
                return "Error interno";
            else if (item === "insufficient_funds")
                return "Fondos insuficientes";
            else if (item === "subscription_inactive")
                return "Convenio inactivo";
            else if (item === "charge_amount_limit_exceeded")
                return "Límite de monto excedido";
            else if (item === "other")
                return "Error desconocido";

        } else {
            return ""
        }

    }

    const status = (item: string) => {
        if (item === "active") {
            return <FormField label={"Activo"}></FormField>;
        } else if (item === "pending") {
            return <FormField label={"Pendiente"}></FormField>;
        } else if (item === "canceled") {
            return <FormField label={"Cancelado"}></FormField>;
        } else {
            return <em>{item}</em>;
        }
    }

    const [sortingColumn, setSortingColumn] = useState<any>({ sortingField: "displayName" });
    const [isDescending, setIsDescending] = useState(false);

    const columns = useMemo(() => [
        {
            id: "displayName",
            header: "Usuario",
            cell: (item: any) => <FormField label={item?.displayName}>
                <BadgeUserType size='small' type='normal' idUserType={item?.idUserType} />
            </FormField>,

            sortingField: "displayName",


        },
        {
            id: "date",
            header: "Fecha",
            cell: (item: any) => <FormField label={format(item?.date, "dd-MM-yyyy")}>
                {format(item?.date, "HH:mm")}
            </FormField>,
            sortingField: "date",
        },
        {
            id: "institution",
            header: "Banco",
            cell: (item: any) => <FormField label={item?.institution}
                constraintText={item?.accountType === "checking_account" ? "Cuenta Corriente" : "Cuenta Vista"}>
                {item?.accountNumber}
            </FormField>,
            sortingField: "institution",
        },
        {
            id: "status",
            header: "Estado",
            cell: (item: any) => status(item?.jsonFintoc?.payment_method?.pac?.status),
            sortingField: "status",

        },
    ], [PACS]);


    const sortedReport = useMemo(() => {
        const data = [...PACS]; // Create a copy of the filtered data to sort
        const { sortingField } = sortingColumn;

        const columnDefinition = columns.find(col => (col as any).sortingField === sortingField) as any;
        const comparator = columnDefinition?.sortingComparator;
        data.sort((a, b) => {
            let result = 0;
            if (comparator) {
                result = comparator(a, b);
            } else if (sortingField) {
                const valA = (a[sortingField] ?? "").toString().toLowerCase();
                const valB = (b[sortingField] ?? "").toString().toLowerCase();
                result = valA.localeCompare(valB);
            }
            return isDescending ? -result : result;
        });

        return data;
    }, [PACS, sortingColumn, isDescending, columns]);


    const [currentPageIndex, setCurrentPageIndex] = useState(1);
    const [filterValue, setFilterValue] = useState("");
    const filtered: any[] = sortedReport.filter((item) => {

        const normalize = (str: string | undefined | null) =>
            (str || "")
                .toString()
                .toLowerCase()
                .normalize("NFD") // Decomposes accented characters (e.g., 'í' -> 'i' + '◌́')
                .replace(/[\u0300-\u036f]/g, "") // Removes the accent marks
                .replace(/[^a-z0-9]/g, ""); // Removes non-alphanumeric

        const searchWords = normalize(filterValue).split(/\s+/).filter(Boolean);
        const text = normalize([item.displayName ?? "", item.userType ?? "",
        item.jsonFintoc.payment_method.pac.account_number ?? "",
        item.jsonFintoc.payment_method.pac.institution.name ?? "",
        item.jsonFintoc.payment_method.pac.account_type ?? ""].join(" "));
        return searchWords.every((word) => text.includes(normalize(word)));
    });
    const paginated = filtered.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={<Favorites />}>Suscripciones PAC</Header>

                    {!!PACS && (


                        <Table
                            filter=
                            {
                                <div style={{ width: 300 }}>
                                    <TextFilter countText={filterValue === "" ? `${sortedReport.length} registros` : `${paginated.length}/${sortedReport.length}`}
                                        filteringPlaceholder="Filtrar"
                                        filteringText={filterValue}
                                        disabled={sortedReport.length === 0}
                                        onChange={({ detail }) => {
                                            setFilterValue(detail.filteringText);
                                            setCurrentPageIndex(1);
                                        }}
                                    />
                                </div>}
                            pagination={
                                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                                    {filtered.length > parameters.pageSize && (
                                        <Pagination
                                            currentPageIndex={currentPageIndex}
                                            pagesCount={Math.ceil(filtered.length / parameters.pageSize)}
                                            onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                                        />
                                    )}

                                    {sortedReport.length > 0 && (
                                        <SelectPaging onSelect={(pageSize) => {
                                            setCurrentPageIndex(1);
                                            setParameters({ ...parameters, pageSize: pageSize });
                                        }} />
                                    )}
                                </SpaceBetween>
                            }
                            sortingColumn={sortingColumn}
                            sortingDescending={isDescending}
                            onSortingChange={(e) => {
                                setSortingColumn(e.detail.sortingColumn);
                                setIsDescending(e.detail.isDescending);
                            }}
                            variant='embedded'
                            columnDefinitions={columns}
                            items={paginated || []}
                        />
                        /*subscriptions.filter((s: any) => s.subscription.id)*/
                    )}
                </SpaceBetween>
            }
        />
    )
};
